import { TCustomerID } from 'modules/settings/models';
import API from 'services/api';

export const deleteUserTypeRole = ({
  roleId,
  payload,
}: {
  roleId: number | null;
  payload: TCustomerID;
}) => {
  return API.delete(`/api/roles/${roleId}`, {
    data: payload,
  });
};
